import React, { Component } from 'react';
import { Header, Segment, Label } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

class Other extends Component {
  render() {
    const errorLabel = <Label color="red" pointing basic />;

    const omsetning = [
      {
        text: '1: Omsetning opp til 500 000',
        value: '1: Omsetning opp til 500 000',
      },
      {
        text: '2: Omsetning fra 500 000 - 2 000 0000',
        value: '2: Omsetning fra 500 000 - 2 000 000',
      },
      {
        text: '3: Omsetning fra 2 000 000 - 3 750 000',
        value: '3: Omsetning fra 2 000 000 - 3 750 000',
      },
      {
        text: '4: Omsetning over 3 750 000',
        value: '4: Omsetning over 3 750 000',
      },
    ];

    return (
      <Segment>
        <Header as="h2">Andre opplysninger</Header>
        <Form.Input
          name="00N3W000000KMxb"
          label="EHF adresse eller Faktura E-post"
          required
          validationErrors={{
            isDefaultRequiredValue: 'Faktura E-post er påkrevd',
          }}
          errorLabel={errorLabel}
        />
        <Form.TextArea
          name="00Nb0000004dyOk"
          label="Hva er dine hovedprodukter?"
          required
          validationErrors={{
            isDefaultRequiredValue:
              'En beskrivelse av dine hovedprodukter er påkrevd',
          }}
          errorLabel={errorLabel}
        />
        <Form.Select
          name="00Nb0000004dyT2"
          label="Omsetning det siste året i kroner (bruttoomsetning ekskl. mva.)"
          required
          validationErrors={{
            isDefaultRequiredValue: 'Omsetning er påkrevd',
          }}
          errorLabel={errorLabel}
          placeholder="Velg omsetning det siste året"
          options={omsetning}
        />
        <div className="ui tiny message">
          Medlemskontingenten beregnes for kommende år etter omsetning for de
          produkter/tjenester som profileres gjennom HANEN og gjelder per
          kalenderår. Medlemskapet gjelder til oppsigelse er sendt til og
          bekreftet av HANEN – jfr. frist i HANENs vedtekter § 7 (
          <a
            href="http://hanen.no/om_hanen"
            target="_blank"
            rel="noopener noreferrer"
          >
            under Om HANEN
          </a>
          ).
        </div>
        <Form.Input name="00Nb0000009w98M" label="Vervet av" />
        <Form.TextArea
          name="00Nb000000ANvbA"
          label="Kommentarer (oppgi relevante sertifiseringer her)"
        />
        <Form.TextArea
          name="00N0X00000D3eyL"
          label="Hvilke forventninger har du til et medlemskap i HANEN?"
        />
      </Segment>
    );
  }
}

export default Other;



// WEBPACK FOOTER //
// ./src/Form/Other.js